import { useStatistics } from './useStatistics';

import DashboardOrnament from '@assets/svgs/DashbordOrnament.svg';

import {
    CollectCard,
    EsgProgrammesCard,
    IncidentsCard,
    SurveysCard,
    TargetsCard,
    TasksCard,
} from '@components/molecules/StatisticsCards';

import { OrnamentWrapper, StatisticsWrapper } from './Statistics.styled';

export const Statistics = () => {
    const { access, loading, statistics } = useStatistics();

    return (
        <StatisticsWrapper>
            <>
                <TasksCard hidden={!access.hasTasksManagerAccess} />
                <TargetsCard hidden={!access.hasMetricsAccess} />
            </>

            <EsgProgrammesCard
                gridSize={access.hasMetricsAccess ? 2 : 1}
                hidden={!access.hasEsgAccess}
                loading={loading.esgStatisticsDataLoading}
                riskAreas={statistics.mostAnsweredRiskAreas}
            />

            <IncidentsCard
                hidden={!access.hasIncidentsAccess}
                loading={loading.statisticsDataLoading}
                statistics={statistics.incidentsStatistics}
            />

            <SurveysCard
                hidden={!access.hasSurveyAccess}
                loading={loading.statisticsDataLoading}
                statistics={statistics.surveyStatistics}
            />

            <CollectCard
                hidden={!access.hasDisclosureAccess}
                loading={loading.statisticsDataLoading}
                statistics={statistics.collectStatistics}
            />

            {access.hasAllAccess && (
                <OrnamentWrapper>
                    <img
                        alt="Dashboard Ornament"
                        src={DashboardOrnament as string}
                    />
                </OrnamentWrapper>
            )}
        </StatisticsWrapper>
    );
};
